<template>
  <div id="app">
    <van-tabbar v-model="pageActive" placeholder>
      <van-tabbar-item icon="search" @click="onsearch()"
        >考勤管理</van-tabbar-item
      >
      <van-tabbar-item icon="friends-o" @click="onWorker()"
        >人员管理</van-tabbar-item
      >
      <van-tabbar-item icon="setting-o" @click="onSetting()"
        >设置</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>
<style lang="less">
.van-tabbar,
.van-tabbar__placeholder {
  height: 66px;
}
.van-icon {
  font-size:larger;
}
</style>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      pageActive: 0,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    onsearch() {
      if (this.$route.path != "/selprolist") {
        this.$router.push("/selprolist");
      }
    },
    onWorker() {
      if (this.$route.path != "/workers") {
        this.$router.push("/workers");
      }
    },
    onSetting() {
      if (this.$route.path != "/loginout") {
        this.$router.push("/loginout");
      }
    },
  },
  created: function () {
    if (this.userInfo.token == "" && this.$route.path != "/") {
      this.$router.push("/");
    }
    if (this.$route.path == "/loginout") {
      this.pageActive = 2;
    } else if (this.$route.path == "/workers") {
      this.pageActive = 1;
    } else{
      this.pageActive = 0;
    }
  },
};
</script>